import Layout from "../app/components/ui/layout/Layout";
import BillingDataPage from "../app/components/Accounting/Recap/BillingDataPage";

const BillingData = () => {
    return (
        <Layout>
            <BillingDataPage />
        </Layout>
    );
};

export default BillingData;